import { render, staticRenderFns } from "./infoContacto.vue?vue&type=template&id=270b791a&scoped=true&"
var script = {}
import style0 from "./infoContacto.vue?vue&type=style&index=0&id=270b791a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b791a",
  null
  
)

export default component.exports